export var makeIcon = function makeIcon(props) {
  var color = props.color,
      size = props.size,
      name = props.name,
      source = props.source;
  return "width: ".concat(size, "px;\n          height: ").concat(size, "px;\n\n          &:before{\n            content: '';\n            display: block;\n            background-color: ").concat(color, ";\n            mask: url(").concat(source, "#").concat(name, "-usage);\n            width: ").concat(size, "px;\n            height: ").concat(size, "px;\n          }");
};